import { FacilitySliceCreator } from './facility-types';
import {
  ActiveCellDetails,
  MasterScheduleSlice,
  MasterScheduleState,
} from './master-schedule-types';

const createInitialMasterScheduleState = (): MasterScheduleState => ({
  overviewOpen: false,
  sideDrawerState: undefined,
  isLoading: false,
  isPageOverlayLoading: false,
  activeCellDetails: {
    unitId: 0,
    dayOfWeek: 0,
  },
});

export const createMasterScheduleSlice: FacilitySliceCreator<
  MasterScheduleSlice
> = (set) => ({
  ...createInitialMasterScheduleState(),

  setOverviewOpen: (value: boolean) =>
    set({
      overviewOpen: value,
    }),

  setSideDrawerState: (value: any) =>
    set({
      sideDrawerState: value,
    }),

  setIsLoading: (value: boolean) =>
    set({
      isLoading: value,
    }),

  setIsPageOverlayLoading: (value: boolean) =>
    set({
      isPageOverlayLoading: value,
    }),

  setActiveCellDetails: (details: ActiveCellDetails) =>
    set({
      activeCellDetails: details,
    }),
});
